<template>
    <div>
        <div class="container">
            <h1>Statistik</h1>
        </div>
        <div class="list">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="statistik__item statistik__item-logins">
                          <div class="statistik__item-login-wrapper">
                            <table
                                id="dtMaterialDesignExample"
                                class="table table-striped"
                                cellspacing="0"
                                width="100%"
                            >
                              <thead>
                              <tr>
                                <th class="th-sm">Vorname</th>
                                <th class="th-sm">Nachname</th>
                                <th class="th-sm">Email</th>
                                <th class="th-sm">Erstelldatum</th>
                                <th class="th-sm">letzter Login</th>
                              </tr>
                              </thead>
                              <tbody>
                                <tr class="entry--item my-5" v-for="login in logins">
                                  <td>{{login.vorname}}</td>
                                  <td>{{login.nachname}}</td>
                                  <td>{{login.email}}</td>
                                  <td>{{ login.creationdate  | date("DD.M.YYYY - HH:mm:ss") }}</td>
                                  <td>{{ login.logintime  | date("DD.M.YYYY - HH:mm:ss") }}</td>
                                </tr>
                              </tbody>
                              <tfoot>
                              <tr>
                                <th class="th-sm">Vorname</th>
                                <th class="th-sm">Nachname</th>
                                <th class="th-sm">Email</th>
                                <th class="th-sm">Erstelldatum</th>
                                <th class="th-sm">letzter Login</th>
                              </tr>
                              </tfoot>
                            </table>
                          </div>
                            <div class="interval__change">
                                <ul>
                                    <li v-on:click="changeInterval(1)" v-bind:class="{'active': timeInterval == 1}">1</li>
                                    <li v-on:click="changeInterval(2)" v-bind:class="{'active': timeInterval == 2}">2</li>
                                    <li v-on:click="changeInterval(5)" v-bind:class="{'active': timeInterval == 5}">5</li>
                                    <li v-on:click="changeInterval(7)" v-bind:class="{'active': timeInterval == 7}">7</li>
                                    <li v-on:click="changeInterval(14)" v-bind:class="{'active': timeInterval == 14}">14</li>
                                </ul>
                            </div>
                            <p>Es gab {{loginAmount}} Logins in den letzten {{timeInterval}} Tagen</p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

</template>

<script>
    import UserService from "@/services/UserService";
    export default {
        name: "Statistik",
        data(){
            return{
                timeInterval: 1,
                loginAmount: 0,
              logins: Object
            }
        },
        methods: {
            getLoginAmount(){
                UserService.getSuchendeLogins(this.timeInterval).then(response =>{
                  this.logins = response.data;
                })
            },
            changeInterval(interval){
                this.timeInterval = interval;
                this.getLoginAmount();
            }
        },
      mounted() {
        this.getLoginAmount();
      }
    }
</script>

<style scoped lang="scss">
    .statistik__item-logins{
        .interval__change{
            ul{
                display: flex;
                justify-content: center;
                align-items: center;
                padding-left: 0px;
                list-style: none;
                li{
                    border: 1px solid black;
                    margin: 0px 5px;
                    padding: 5px 15px;
                    cursor: pointer;
                    transition: 0.25s ease-out;
                    &.active{
                        border-color: red;
                    }
                }
            }
        }
    }
</style>